import type { FrameOption } from './types';

// Print sizes live in D1 (print_sizes) and arrive per photo from the API as
// `print_sizes` — see workers/api/utils/print-sizes.js.

export const FRAME_OPTIONS: FrameOption[] = [
  { id: 'none', label: 'Print Only', priceCents: 0 },
  { id: 'classic_black', label: 'Classic Black Frame', priceCents: 3500 },
  { id: 'modern_white', label: 'Modern White Frame', priceCents: 3500 },
  { id: 'oak', label: 'Natural Oak Frame', priceCents: 4500 },
];

export const FRAME_OPTIONS_BY_ID: Record<string, FrameOption> = Object.fromEntries(
  FRAME_OPTIONS.map((f) => [f.id, f])
);
